// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2KZtz","disabled":"FileBtn_disabled__8yk_K","warn":"FileBtn_warn__2C-MG","fade":"FileBtn_fade__wBb62"};